import React, { useState } from 'react';

import { getUserName } from '../../../utilities';
import { SubmitButton, Button } from '../../../components';
import { Dropdown, Form, FormItem } from '../../../components';
import type { UserListType, AssignUserToRolePayload } from './useUsers';

type PartialForm = Partial<AssignUserToRolePayload>;

type AssignUserFormProps = {
  saving: boolean;
  userId: string;
  user?: UserListType;

  onCancel: () => void;
  onSave: (form: AssignUserToRolePayload) => void;

  roles: OptionType[];
  organizations: OptionType[];
};

export const AssignUserForm: React.FC<AssignUserFormProps> = ({
  user,
  userId,
  saving,

  onSave,
  onCancel,

  roles,
  organizations,
}) => {
  const [values, setValues] = useState<PartialForm>({ userId });

  return (
    <div className="flex flex-col gap-y-12 w-full">
      <div className="text-medium">Select organization you want assign to:</div>
      <div className="text-medium font-medium">{getUserName(user)}</div>
      <Form onChange={setValues} initialValue={values}>
        <FormItem<PartialForm>
          required
          inline={false}
          label="Organization"
          name="organizationId"
        >
          <Dropdown options={organizations} placeholder="Select organization" />
        </FormItem>
        <FormItem<PartialForm>
          required
          label="Role"
          name="roleId"
          inline={false}
        >
          <Dropdown options={roles} placeholder="Select role" />
        </FormItem>

        <div className="flex flex-col gap-y-md justify-center items-center">
          <SubmitButton
            size="large"
            label="Assign"
            disabled={saving}
            className="w-full"
            onClick={() => onSave(values as AssignUserToRolePayload)}
          />
          <Button
            size="large"
            type="light"
            label="Cancel"
            className="w-full"
            onClick={onCancel}
          />
        </div>
      </Form>
    </div>
  );
};
